import { render, staticRenderFns } from "./LayoutIndex.vue?vue&type=template&id=19166734&scoped=true"
import script from "./LayoutIndex.vue?vue&type=script&lang=js"
export * from "./LayoutIndex.vue?vue&type=script&lang=js"
import style0 from "./LayoutIndex.vue?vue&type=style&index=0&id=19166734&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19166734",
  null
  
)

export default component.exports